import { watch } from 'vue'
import { useConsentStore } from '~~/stores/consentStore'
import { useMetaTracking } from '~~/app/composables/useMetaTracking'
import { isCartRecoverPath } from '~~/shared/utils/cartRecover'

/**
 * Meta PageView na każdą nawigację (pixel + most CAPI). Pixel Plus robi tylko
 * `fbq('init')` bez auto-PageView, więc bez tego zdarzenie PageView NIE leciało wcale.
 *
 * noBuffer:true — PageView jest wysokoczęstotliwościowy i mało wartościowy przy odtwarzaniu,
 * więc przed zgodą go NIE buforujemy (żeby nie wypychać z bufora cennych AddToCart/checkout).
 * Zamiast tego: gdy zgoda marketingowa zostaje udzielona, odpalamy PageView bieżącej strony.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const meta = useMetaTracking()
  const router = useRouter()
  const consent = useConsentStore()
  let lastPath = ''

  function controllerOf(route: { name?: unknown; path?: string }): string {
    return String(route?.name || route?.path || 'index')
  }

  function firePageView(route: { fullPath: string; path: string; name?: unknown }) {
    // Adres /cart-recover niesie token koszyka z maila — nie wysyłamy go do Mety
    // (Pixel `dl`, CAPI event_source_url). Odsłonę liczymy dopiero na /cart.
    if (isCartRecoverPath(route.path)) return
    const path = route.fullPath
    if (!path || path === lastPath) return
    lastPath = path
    meta.fire('PageView', {}, { controller: controllerOf(route) }, { noBuffer: true })
  }

  // Pierwsze wejście — po hydracji SSR router.afterEach nie odpala się dla trasy startowej.
  nuxtApp.hook('app:mounted', () => firePageView(router.currentRoute.value))

  // Kolejne nawigacje SPA.
  router.afterEach((to) => firePageView(to))

  // Udzielenie zgody na bieżącej stronie (bez nawigacji) — odpal PageView tej strony.
  watch(
    () => consent.current.marketing,
    (granted) => {
      if (!granted) return
      lastPath = ''
      firePageView(router.currentRoute.value)
    },
  )
})
